import React, { useEffect, useState } from 'react';
import CreateCatalog from './CreateCatalog';
import CatalogLedgerList from './CatalogLedgerList';
import { getCatalogList, saveCatalog, updateCatalog } from '../../../services/catalog/catalogService';
import { toast } from "../../../components/AppToast";

const CatalogMgt = () => {
    const [catalogItems, setCatalogItems] = useState([]);
    const [pagination, setPagination] = useState({ totalRecords: 0, currentPage: 1, totalPages: 1, limit: 10 });
    const [isCreating, setIsCreating] = useState(false);
    const [activeRecord, setActiveRecord] = useState(null);

    const onlyFormVisible = isCreating || !!activeRecord;

    const closeForm = () => {
        setIsCreating(false);
        setActiveRecord(null);
    };

    useEffect(() => {
        fetchCatalogItems(1, pagination.limit);
    }, []);

    const fetchCatalogItems = async (page = 1, limit = 10) => {
        try {
            const { data, pagination: pg } = await getCatalogList(page, limit);
            setCatalogItems(data);
            setPagination(pg);
        } catch (err) {
            console.error("Error fetching catalog items:", err);
        }
    };

    const submitForm = async (formData, id) => {
        try {
            if (id) {
                const updateRes = await updateCatalog(formData, id);
                if (updateRes?.status) {
                    toast.success("Catalog item updated successfully");
                    await fetchCatalogItems(pagination.currentPage, pagination.limit);
                    closeForm();
                } else {
                    toast.error("Catalog item update failed");
                }
            } else {
                const result = await saveCatalog(formData);
                if (result?.status === 201 || result?.statusText === "Created") {
                    toast.success("Catalog item created successfully");
                    await fetchCatalogItems(1, pagination.limit);
                    closeForm();
                } else {
                    toast.error("Catalog item creation failed");
                }
            }
        } catch (err) {
            console.error("Submit form error:", err);
            const message =
                err?.response?.data?.message ||
                err?.message ||
                "Something went wrong";
            toast.error(message);
        }
    };

    return (
        <div className="card shadow-lg main-card">
            {/* ---------- HEADER ---------- */}
            <div className="card-header bg-secondary text-white d-flex justify-content-between align-items-center">
                <h4 className="mb-0 h6 fw-semibold">
                    {!onlyFormVisible
                        ? "Catalog"
                        : isCreating
                            ? "Create Catalog"
                            : activeRecord?.mode === "edit"
                                ? "Edit Catalog"
                                : "View Catalog"}
                </h4>
            </div>

            {/* ---------- BREADCRUMBS ---------- */}
            {onlyFormVisible && (
                <nav
                    aria-label="breadcrumb"
                    className="px-3 py-2 border-bottom bg-light"
                >
                    <ol
                        className="breadcrumb mb-0 align-items-center"
                        style={{ ["--bs-breadcrumb-divider"]: "'/'" }}
                    >
                        <li className="breadcrumb-item">
                            <button
                                type="button"
                                className="btn btn-link p-0 text-decoration-none text-muted"
                                onClick={closeForm}
                            >
                                Catalog
                            </button>
                        </li>
                        <li
                            className="breadcrumb-item active fw-semibold text-primary"
                            aria-current="page"
                        >
                            {isCreating
                                ? "Create Catalog"
                                : activeRecord?.mode === "edit"
                                    ? "Edit Catalog"
                                    : "View Catalog"}
                        </li>
                    </ol>
                </nav>
            )}

            {/* ---------- BODY ---------- */}
            <div className="card-body">
                {!onlyFormVisible ? (
                    <CatalogLedgerList
                        catalogItems={catalogItems}
                        pagination={pagination}
                        onPageChange={(page, limit) => fetchCatalogItems(page, limit)}
                        onCreateClick={() => setIsCreating(true)}
                        onView={(row) =>
                            setActiveRecord({ mode: "view", data: row })
                        }
                        onEdit={(row) =>
                            setActiveRecord({ mode: "edit", data: row })
                        }
                    />
                ) : (
                    <CreateCatalog
                        initialValues={activeRecord?.data || {}}
                        onCancel={closeForm}
                        onSubmit={submitForm}
                        viewOnly={activeRecord?.mode === "view"}
                        isEdit={activeRecord?.mode === "edit"}
                    />
                )}
            </div>
        </div>
    );
};

export default CatalogMgt;
